import { CreativeTagEvent, ViewabilityEventConditions } from '../enums';
import { EventEmitter } from '../types';
import { ViewabilityObserver } from '../types/viewability-observer';

export class DisplayEventNotifier {
  private isEventEmitted = false;
  constructor(
    observer: ViewabilityObserver,
    private readonly emitter: EventEmitter<CreativeTagEvent>
  ) {
    observer.on(ViewabilityEventConditions.On50PercentVisible, () =>
      this.handleEvent()
    );
  }
  public handleEvent() {
    if (!this.isEventEmitted) {
      this.emitter.emit(CreativeTagEvent.CreativeDisplay);
      this.isEventEmitted = true;
    }
  }
}
